/**
 * Scorecard Visibility API
 * API functions for scorecard visibility feature
 */

import { http } from '@/lib/ats-https';
import { type ScorecardVisibilityResponse } from '@/components/shared/interviews-revamp/scorecard/scorecard-visibility/types';

/**
 * Fetch scorecards with visibility data (current interview + history)
 */
export const getScorecardsByInterviewId = async ({
  applicationId,
  interviewId,
  shouldShowHistory = false,
  hasTransferInfo: _hasTransferInfo = false,
}: {
  applicationId: number;
  interviewId: number;
  shouldShowHistory?: boolean;
  hasTransferInfo?: boolean;
}): Promise<ScorecardVisibilityResponse> => {
  const include = shouldShowHistory
    ? _hasTransferInfo
      ? ['history', 'transferred']
      : ['history']
    : undefined;

  const response = await http.get(
    `/ats_applications/${applicationId}/ats_scorecards`,
    {
      params: {
        ats_interview_id: interviewId,
        ...(include ? { include } : {}),
      },
    }
  );

  return response;
};

/**
 * Send reminder for a scorecard
 */
export const sendScorecardReminder = async ({
  scorecardId,
}: {
  scorecardId: number;
}): Promise<unknown> => {
  const response = await http.post(`/ats_scorecards/${scorecardId}/reminder`);

  return response;
};

/**
 * Submit scorecard
 */
export const submitScorecard = async ({
  applicationId,
  scorecardId,
  payload,
}: {
  applicationId: number;
  scorecardId: number;
  payload: {
    rating: string;
    feedback: string;
    questions: unknown[];
    status: string;
  };
}): Promise<unknown> => {
  const response = await http.put(
    `/ats_applications/${applicationId}/ats_scorecards/${scorecardId}`,
    payload
  );

  return response;
};

export const SCORECARD_VISIBILITY_API = {
  getScorecardsByInterviewId,
  sendScorecardReminder,
  submitScorecard,
};
